import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataSummaryStore } from 'src/app/features/questionnaires/store/data-summary-store';
import { AnswerByRecipient, QuestionData } from 'src/app/models/QuestionnaireDataByQuestions.model';
import { toSignal } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';
import { AnswerGroupToRecipientComponent } from './answer-group-to-recipient/answer-group-to-recipient.component';
import { QuestionTitlePipe } from '../question-title.pipe';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { Recipient } from 'src/app/models/recipients.model';
import { DataSummaryApiService } from 'src/app/features/questionnaires/services/data-summary-api-service';

@Component({
    selector: 'que-answers-in-table-or-group',
    imports: [CommonModule, AnswerGroupToRecipientComponent, QuestionTitlePipe, TranslateDirective, TranslatePipe],
    templateUrl: './answers-in-table-or-group.component.html',
    styleUrls: ['./answers-in-table-or-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AnswersInTableOrGroupComponent {
  @Input()
  questionData?: QuestionData;
  #storeData = inject(DataSummaryStore);
  date$ = toSignal(this.#storeData.createDate$);
  #dataSummaryApiService = inject(DataSummaryApiService)
  filterRecipients$ = toSignal(this.#storeData.recipientsToFilterId$.pipe(tap(x => this.filterTheRecipientsById(x))));
  // filterRecipients$ = toSignal(this.#storeData.recipientsToFilterId$.pipe(tap(x => this.filterTheRecipientsById(x))));
  recipients?: Recipient[];
  showAll: boolean = false;
  showComparison$ = toSignal(this.#storeData.showComparison$);

  ngOnInit(): void {
  }
  ngOnChanges() {
    this.filterTheRecipients();
  console.log('[answers] qId=', this.questionData?.question?.id,
              'recipients=', this.questionData?.recipients?.length,
              'recipientIds=', (this.questionData?.recipients ?? []).map((r:any) => r?.recipient?.id));
}
  filterTheRecipients() {
    var recipientsOnly: Recipient[] = [];
    if (this.filterRecipients$()!=undefined) {
      recipientsOnly = [...(this.questionData?.recipients?.filter(r => r.recipient.user.id == this.filterRecipients$()) ?? []).map(x => x.recipient)];
    }
    else {
      if (this.questionData?.recipients) { recipientsOnly = this.questionData?.recipients.map(x => x.recipient); }
    }
    this.recipients = this.removeDuplicateRecipientsByName(recipientsOnly);
  }

  filterTheRecipientsById(userId?: number) {
    var recipientsOnly: Recipient[] = [];
    if (userId!=undefined) {
      recipientsOnly = [...(this.questionData?.recipients?.filter(r => r.recipient.user.id == userId) ?? []).map(x => x.recipient)];
    }
    else {
      if (this.questionData?.recipients) { recipientsOnly = this.questionData?.recipients.map(x => x.recipient); }
    }
    this.recipients = this.removeDuplicateRecipientsByName(recipientsOnly);
  }
  removeDuplicateRecipientsByName(recipients: Recipient[]): Recipient[] {
    const uniqueRecipientsMap = new Map<number, Recipient>();

    recipients.forEach(recipient => {
      if (!uniqueRecipientsMap.has(recipient.id)) {
        uniqueRecipientsMap.set(recipient.id, recipient);
      }
    });

    return Array.from(uniqueRecipientsMap.values());
  }
  export() {
    this.#dataSummaryApiService.ExporModularQuestionDataSummarytToExcel(this.questionData?.question.id!, this.showComparison$() ?? false, this.questionData?.question.title, this.date$())
  }
}
